import React, { useCallback, useState } from "react";

import { useParams } from "react-router-dom";

import CompellonApi from "apis/compellon";
import { PageLoader } from "clearsense-ui/components";
import useJobResultData from "hooks/useJobResultData";
import useSearchAndPaginate from "hooks/useSearchAndPaginate";

import { DEFAULT_PAGE_NUMBER, MINIMUM_PAGE_SIZE } from "./constants";
import NewWhatIf from "./New";
import Table from "./Table";
import { getConditions } from "./Utils/apiDataConverters";
import View from "./View";

const WhatIf = ({
  isOutputsLoading,
  outputs,
  setOutputs,
  isNewWhatIfPaneOpen,
  setIsNewWhatIfPaneOpen,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const [whatIfs, setWhatIfs] = useState({ data: [], count: 0 });
  const [selectedWhatIf, setSelectedWhatIf] = useState(null);
  const [isWhatIfModalOpen, setIsWhatIfModalOpen] = useState(false);

  const { analysisId } = useParams();

  const { loading: modelDriversLoading, data: modelDrivers } = useJobResultData(
    outputs,
    setOutputs,
    "binary_model_drivers"
  );

  const fetchWhatIfs = useCallback(async () => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams(window.location.search);
      const currentPage = params.get("page") || DEFAULT_PAGE_NUMBER;
      const pageSize = params.get("per_page") || MINIMUM_PAGE_SIZE;
      const payload = {
        job_type: "binary_what_if",
        job_id: analysisId,
        per_page: pageSize,
        page: currentPage,
      };
      const {
        data: { job_list, job_count },
      } = await CompellonApi.fetchSubJobs(payload);
      setWhatIfs({ count: job_count, data: handleWhatIfList(job_list) });
    } catch (error) {
      logger.error(error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const { currentPage, pageSize, setCurrentPage, setPageSize } =
    useSearchAndPaginate(
      fetchWhatIfs,
      {},
      DEFAULT_PAGE_NUMBER,
      MINIMUM_PAGE_SIZE
    );

  const handleWhatIfList = subJobs =>
    subJobs.map(({ id, status, start_time, name }) => ({
      id,
      status,
      runDate: start_time,
      name,
    }));

  const handleClick = selectedId => {
    setSelectedWhatIf(whatIfs?.data?.find(({ id }) => id === selectedId));
    setIsWhatIfModalOpen(true);
  };

  if (isOutputsLoading) {
    return <PageLoader />;
  }

  return (
    <>
      {selectedWhatIf && whatIfs.count > 0 && (
        <View
          isWhatIfModalOpen={isWhatIfModalOpen}
          setIsWhatIfModalOpen={setIsWhatIfModalOpen}
          selectedWhatIf={selectedWhatIf}
          variableDataLoading={modelDriversLoading}
          variableData={modelDrivers?.variable_list}
        />
      )}
      <Table
        isLoading={isLoading}
        whatIfs={whatIfs}
        handleClick={handleClick}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
      {modelDrivers && (
        <NewWhatIf
          isNewWhatIfPaneOpen={isNewWhatIfPaneOpen}
          setIsNewWhatIfPaneOpen={setIsNewWhatIfPaneOpen}
          conditions={getConditions(modelDrivers.variable_list)}
          fetchWhatIfs={fetchWhatIfs}
        />
      )}
    </>
  );
};

export default WhatIf;
